module.exports = __webpack_public_path__ + "img/Img1_204712_BiEr-14-CR-267.35bcf605.jpg";